import config from './config';
import request from '../common/request';

export default { request, config };
